export default function (element, binding) {
  const locale = binding.value?.locale || 'en-GB'

  if (!element.tagName) return

  const isInputElement = element.tagName.toLocaleUpperCase() === 'INPUT'
  let targetElement = element

  // Handle non-input elements by finding or creating a nested input for operations.
  if (!isInputElement) {
    const els = element.getElementsByTagName('input')
    if (els.length) {
      targetElement = els[0]
    } else {
      // If it's not an input and doesn't contain an input, treat it as a text element.
      targetElement = null
    }
  }

  const formatValue = value => (value ? parseFloat(value.replace(/[^-\d.]/g, '')).toLocaleString(locale) : '')

  const updateElement = (el, value) => {
    if (isInputElement) {
      el.value = formatValue(value)
    } else if (el) {
      el.textContent = formatValue(value)
    } else {
      element.textContent = formatValue(element.textContent)
    }
  }

  if (targetElement) {
    // Acts when something is added into the input element.
    targetElement.oninput = function () {
      const inputValue = targetElement.value
      updateElement(targetElement, inputValue)

      // Dispatches change event for the current input.
      targetElement.dispatchEvent(new Event('change'))
    }

    targetElement.oninput()
  } else {
    // For non-input elements, simply format the text content initially.
    updateElement(null, element.textContent)
  }

  // Forces the format after the initialization for input elements.
  if (isInputElement) {
    targetElement.dispatchEvent(new Event('input'))
  }
}
